import isBefore from "date-fns/isBefore";
import parseISO from "date-fns/parseISO";
import startOfToday from "date-fns/startOfToday";

export function sortAlphabetically(keyToSort) {
  return function (objOne, objTwo) {
    const nameA = objOne[keyToSort].toUpperCase();
    const nameB = objTwo[keyToSort].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  };
}

export function extractContentFromHTML(html) {
  return new DOMParser().parseFromString(html, "text/html").documentElement
    .textContent;
}

export function isChecklistPublished(status, publishedDate) {
  const date =
    typeof publishedDate === "string" ? parseISO(publishedDate) : publishedDate;
  return status === "Published" && isBefore(date, startOfToday());
}

export function nextMonthUtc(year, month) {
  let nextMonth = month + 1;
  let nextYear = year;

  if (nextMonth === 13) {
    nextMonth = 1;
    nextYear += 1;
  }

  return new Date(Date.UTC(nextYear, nextMonth - 1));
}

// Convert well-formed camelCase to Title Case with spaces.
// Example: "userMoneyPersonality" -> "User Money Personality"
export function camelCaseToTitle(input) {
  if (input == null) return "";
  const str = String(input).replace(/([a-z])([A-Z])/g, "$1 $2");
  return str.charAt(0).toUpperCase() + str.slice(1);
}
